export interface ErrorModel {
  message?: string;
  type?: string;
}

/** Error codes returned by the group endpoints within the 400 body. */
export enum GroupMessageError {
  ALREADY_EXISTING_GROUP_BY_EXTERNAL_GROUP_INFO_GIVEN = 'ALREADY_EXISTING_GROUP_BY_EXTERNAL_GROUP_INFO_GIVEN',
}
